export default __webpack_public_path__ + "static/media/login_side_image_hcp.d24dd8c9.jpg";